export default {"src":"/_next/static/image/src/images/account/icon-get-help.50c4903c5d89dccd6b5aa3d0f6745ca3.svg","height":96,"width":96};